// تحويل روابط Cloudinary لصور مصغرة أو بجودة كاملة
export function getThumbUrl(url, width = 400) {
    if (!url || !url.includes('res.cloudinary.com')) return url;
    return url.replace('/image/upload/', '/image/upload/q_auto,f_auto,w_' + width + '/');
}

export function getFullUrl(url) {
    if (!url || !url.includes('res.cloudinary.com')) return url;
    return url.replace('/image/upload/', '/image/upload/q_auto,f_auto/');
}

export function isFirebaseUrl(url) {
    return url && url.includes('firebasestorage.googleapis.com');
}

// فحص توفر صورة - يعيد true إذا الصورة متاحة
export function checkImageAvailable(url) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });
}

// معالج الخطأ للصور - يحاول مصادر بديلة ثم يعرض placeholder
export function handleImageError(e, fallbackUrls) {
    const img = e.target;
    const index = parseInt(img.dataset.fallbackIndex || '0', 10);
    const urls = Array.isArray(fallbackUrls) ? fallbackUrls : (fallbackUrls ? [fallbackUrls] : []);
    
    if (index < urls.length) {
        img.dataset.fallbackIndex = (index + 1).toString();
        img.src = urls[index];
        return;
    }
    
    // استنفدت كل البدائل — عرض صورة بديلة
    img.src = 'data:image/svg+xml,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" fill="%23ddd"><rect width="400" height="300"/><text x="50%" y="50%" text-anchor="middle" fill="%23999" font-size="16" dy=".3em">صورة غير متاحة</text></svg>'
    );
}
